import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    PLANTS_QUERY,
    SINGLE_PLANT_QUERY,
    CREAT_PLANT_MUTATION,
    UPDATE_PLANT_MUTATION,
    DELETE_PLANT_MUTATION
} from "@/graphql/plants.js";

const state = {
    plants: []
    // currentPlant: null
};
const getters = {};
const mutations = {
    [types.SET_PLANTS](state, plants) {
        state.plants = plants;
    },
    [types.SORT_PLANTS](state) {
        state.plants.sort(function(a, b) {
            return a.node.name.toLowerCase() == b.node.name.toLowerCase()
                ? 0
                : a.node.name.toLowerCase() > b.node.name.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_PLANT](state, plant) {
        var index = state.plants.findIndex(function(element) {
            return element.node.id == plant.id;
        });

        const node = { node: plant };

        if (index > -1) {
            state.plants.splice(index, 1, node);
        } else {
            state.plants.unshift(node);
        }
    },
    [types.DELETE_PLANT](state, plant) {
        var index = state.plants.find(function(element, index) {
            if (element.id == plant.id) {
                return index;
            }
        });

        if (index > -1) {
            state.plants.splice(index, 1);
        }
    }
};
const actions = {
    async fetchPlants(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PLANTS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    // console.log(response);
                    const plants = response.data.tenantPlants.edges;

                    // update store
                    context.commit(types.SET_PLANTS, plants);

                    // sort
                    context.commit(types.SORT_PLANTS);

                    resolve(plants);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSinglePlant(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_PLANT_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        id: payload
                    }
                })
                .then(response => {
                    var plant = JSON.parse(JSON.stringify(response.data.plant));

                    // update store
                    context.commit(types.UPSERT_PLANT, plant);

                    // sort
                    context.commit(types.SORT_PLANTS);

                    resolve(plant);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createPlant(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREAT_PLANT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plant = response.data.createPlant.plant;

                    // update store
                    context.commit(types.UPSERT_PLANT, plant);

                    // sort
                    context.commit(types.SORT_PLANTS);

                    resolve(plant);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updatePlant(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_PLANT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plant = response.data.updatePlant.plant;

                    // update store
                    context.commit(types.UPSERT_PLANT, plant);

                    // sort
                    context.commit(types.SORT_PLANTS);

                    resolve(plant);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deletePlant(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_PLANT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plant = response.data.deletePlant.plant;

                    // update store
                    context.commit(types.DELETE_PLANT, plant);

                    resolve(plant);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
